"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upDownStepLengthMM = exports.joystickTurnMaxDegs = exports.joystickStepMaxMM = exports.default = void 0;
require("core-js/modules/es.number.to-fixed.js");
require("./styles.css");
var _arrowUp = require("../../assets/pad-controller/arrow-up.svg");
var _arrowBottom = require("../../assets/pad-controller/arrow-bottom.svg");
var _arrowLeft = require("../../assets/pad-controller/arrow-left.svg");
var _arrowRight = require("../../assets/pad-controller/arrow-right.svg");
var _arrowTurnLeft = require("../../assets/pad-controller/arrow-turn-left.svg");
var _arrowTurnRight = require("../../assets/pad-controller/arrow-turn-right.svg");
var _Joystick = _interopRequireDefault(require("./Joystick"));
var _react = require("react");
var _speedContext = _interopRequireDefault(require("../../store/speed-context"));
var _RCSequencerManager = _interopRequireDefault(require("../../utils/RCSequencer/RCSequencerManager"));
var _Movement = _interopRequireDefault(require("../../utils/RCSequencer/Movement"));
var _calculateStepInterval = _interopRequireDefault(require("../../utils/RCSequencer/calculateStepInterval"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const upDownStepLengthMM = exports.upDownStepLengthMM = 25;
const joystickStepMaxMM = exports.joystickStepMaxMM = 30;
const joystickTurnMaxDegs = exports.joystickTurnMaxDegs = 20;
const PadControllerSection = _ref => {
  let {
    isDeactivated
  } = _ref;
  const speedCtx = (0, _react.useContext)(_speedContext.default);
  const onArrowClick = direction => {
    if (isDeactivated) return;
    switch (direction) {
      case "turnLeft":
        _RCSequencerManager.default.addToSequence(new _Movement.default("step", direction, speedCtx.speed, {
          // reduce step length if moveTime drops below 1 second
          stepLength: (0 * joystickStepMaxMM * Math.min((0, _calculateStepInterval.default)(speedCtx.speed) / 1000, 1)).toFixed(1),
          turn: (-1 * joystickTurnMaxDegs * -1).toFixed(1),
          moveTime: (0, _calculateStepInterval.default)(speedCtx.speed)
        }));
        break;
      case "turnRight":
        _RCSequencerManager.default.addToSequence(new _Movement.default("step", direction, speedCtx.speed, {
          // reduce step length if moveTime drops below 1 second
          stepLength: (0 * joystickStepMaxMM * Math.min((0, _calculateStepInterval.default)(speedCtx.speed) / 1000, 1)).toFixed(1),
          turn: (1 * joystickTurnMaxDegs * -1).toFixed(1),
          moveTime: (0, _calculateStepInterval.default)(speedCtx.speed)
        }));
        break;
      case "stepUp":
      case "stepDown":
        _RCSequencerManager.default.addToSequence(new _Movement.default("step", direction, speedCtx.speed, {
          stepLength: direction === "stepDown" ? -upDownStepLengthMM : upDownStepLengthMM,
          moveTime: (0, _calculateStepInterval.default)(speedCtx.speed)
        }));
        break;
      case "sidestepLeft":
      case "sidestepRight":
        _RCSequencerManager.default.addToSequence(new _Movement.default("sidestep", direction, speedCtx.speed, {
          side: direction === "sidestepLeft" ? 0 : 1,
          moveTime: (0, _calculateStepInterval.default)(speedCtx.speed)
        }));
        break;
      default:
        break;
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
    className: "pad-controller-section",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "pad-controller-arrow pad-controller-arrow-up ".concat(isDeactivated ? "pad-controller-arrow-deactivated" : ""),
      onClick: () => onArrowClick("stepUp"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowUp.ReactComponent, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "pad-controller-arrow pad-controller-arrow-down ".concat(isDeactivated ? "pad-controller-arrow-deactivated" : ""),
      onClick: () => onArrowClick("stepDown"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowBottom.ReactComponent, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "pad-controller-arrow pad-controller-arrow-left ".concat(isDeactivated ? "pad-controller-arrow-deactivated" : ""),
      onClick: () => onArrowClick("sidestepLeft"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowLeft.ReactComponent, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Joystick.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "pad-controller-arrow pad-controller-arrow-right ".concat(isDeactivated ? "pad-controller-arrow-deactivated" : ""),
      onClick: () => onArrowClick("sidestepRight"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowRight.ReactComponent, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "pad-controller-arrow pad-controller-arrow-turn-left ".concat(isDeactivated ? "pad-controller-arrow-deactivated" : ""),
      onClick: () => onArrowClick("turnLeft"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowTurnLeft.ReactComponent, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "pad-controller-arrow pad-controller-arrow-turn-right ".concat(isDeactivated ? "pad-controller-arrow-deactivated" : ""),
      onClick: () => onArrowClick("turnRight"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowTurnRight.ReactComponent, {})
    })]
  });
};
var _default = exports.default = PadControllerSection;